import React, { useState } from "react";
import { toast } from "react-toastify"
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import {
  isPast, isEqual
} from "date-fns"
import SweetAlert from "react-bootstrap-sweetalert"
import CustomSimpleDatePicker from "components/CustomSimpleDatePicker";
import { updateSurveyorAssignmentStartTime } from "requesters/jobServiceRequester";
import { getBaseUrl } from "../../reducers";

const AssignmentStartTime = ({
  jobService, reloadData, readOnly, assignment
}) => {
  const {
    attributes: {
      id,
      disabledChangeOnSchedule
    }
  } = jobService
  const {
    id: assignmentId, attributes: {
      start_at: startTime,
    }
  } = assignment

  const [newStartTime, setNewStartTime] = useState(startTime && new Date(startTime));
  const [requesting, setRequesting] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [alertType, setAlertType] = useState("error");
  const [alertTitle, setAlertTitle] = useState("");
  const [alertText, setAlertText] = useState("");
  const baseUrl = useSelector(getBaseUrl)

  const hideAlert = () => {
    setShowMessage(false);
  }

  const handleTimeChange = newTime => {
    if (!readOnly) {
      setNewStartTime(newTime)
    }
  }

  const toastError = err => {
    toast.error(
      <div>
        <span role="img" aria-label="failure-icon">❌</span>
        <span className="ml-2">{err?.response?.data?.errors[0]?.detail}</span>
      </div>,
      {
        toastId: "container-inner",
        containerId: "main"
      }
    )
  }

  const onUpdate = async () => {
    if (!startTime || isEqual(new Date(startTime), newStartTime)) return

    if (!isPast(newStartTime)) {
      setRequesting(true)
      updateSurveyorAssignmentStartTime(baseUrl, id, { surveyor_assignment_id: assignmentId, new_start_time: newStartTime })
        .then(res => {
          if (res.status === 200) {
            setRequesting(false)
            reloadData()
          }
        })
        .catch(err => {
          setRequesting(false)
          toastError(err)
        })
    } else if (isPast(newStartTime)) {
      setShowMessage(true)
      setAlertTitle("Please choose an available time slot!")
      setAlertText("You can only choose a time slot in the future!")
      setNewStartTime(new Date(startTime))
    }
  }

  return (
    <React.Fragment>
      <CustomSimpleDatePicker
        closeOnScroll
        readOnly={readOnly || disabledChangeOnSchedule}
        showTimeSelect
        popperPlacement="bottom-end"
        selected={new Date(newStartTime)}
        dateFormat="h:mm aa"
        requesting={requesting}
        onChange={newTime => { handleTimeChange(newTime) }}
        onCalendarClose={() => onUpdate()}
        onClickOutside={() => { setShowMessage(false) }} />
      <SweetAlert
        show={showMessage}
        type={alertType}
        title={alertTitle}
        style={{ width: "600px" }}
        closeOnClickOutside
        allowEscape={false}
        onConfirm={hideAlert}>
        {alertText}
      </SweetAlert>
    </React.Fragment>
  )
};

export default AssignmentStartTime;